import { emptySplitApi as api } from './emptyApi';
export const addTagTypes = ['assignments'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      assignmentsList: build.query<
        AssignmentsListApiResponse,
        AssignmentsListApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            contains_timestamp: queryArg.containsTimestamp,
            deleted_objects: queryArg.deletedObjects,
            drivers: queryArg.drivers,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            search: queryArg.search,
            unassigned: queryArg.unassigned,
            vehicles: queryArg.vehicles,
          },
        }),
        providesTags: ['assignments'],
      }),
      assignmentsCreate: build.mutation<
        AssignmentsCreateApiResponse,
        AssignmentsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/`,
          method: 'POST',
          body: queryArg.assignmentBulkCreate,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['assignments'],
      }),
      assignmentsRetrieve: build.query<
        AssignmentsRetrieveApiResponse,
        AssignmentsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        providesTags: ['assignments'],
      }),
      assignmentsPartialUpdate: build.mutation<
        AssignmentsPartialUpdateApiResponse,
        AssignmentsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedAssignment,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['assignments'],
      }),
      assignmentsDestroy: build.mutation<
        AssignmentsDestroyApiResponse,
        AssignmentsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['assignments'],
      }),
      assignmentsBreaksList: build.query<
        AssignmentsBreaksListApiResponse,
        AssignmentsBreaksListApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/breaks/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['assignments'],
      }),
      assignmentsBreaksCreate: build.mutation<
        AssignmentsBreaksCreateApiResponse,
        AssignmentsBreaksCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/breaks/`,
          method: 'POST',
          body: queryArg.assignmentBreak,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['assignments'],
      }),
      assignmentsBreaksRetrieve: build.query<
        AssignmentsBreaksRetrieveApiResponse,
        AssignmentsBreaksRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/breaks/${queryArg.breakId}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['assignments'],
      }),
      assignmentsBreaksPartialUpdate: build.mutation<
        AssignmentsBreaksPartialUpdateApiResponse,
        AssignmentsBreaksPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/breaks/${queryArg.breakId}/`,
          method: 'PATCH',
          body: queryArg.patchedAssignmentBreak,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['assignments'],
      }),
      assignmentsBreaksDestroy: build.mutation<
        AssignmentsBreaksDestroyApiResponse,
        AssignmentsBreaksDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/breaks/${queryArg.breakId}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['assignments'],
      }),
      assignmentsBreaksActiveList: build.query<
        AssignmentsBreaksActiveListApiResponse,
        AssignmentsBreaksActiveListApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/breaks/active/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['assignments'],
      }),
      assignmentsDriverCallRequestsCreate: build.mutation<
        AssignmentsDriverCallRequestsCreateApiResponse,
        AssignmentsDriverCallRequestsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/driver-call-requests/`,
          method: 'POST',
          body: queryArg.driverCallRequest,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['assignments'],
      }),
      assignmentsDriverCallRequestsCancelPartialUpdate: build.mutation<
        AssignmentsDriverCallRequestsCancelPartialUpdateApiResponse,
        AssignmentsDriverCallRequestsCancelPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/driver-call-requests/${queryArg.driverCallRequestId}/cancel/`,
          method: 'PATCH',
          body: queryArg.patchedDriverCallRequest,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['assignments'],
      }),
      assignmentsDriverCallRequestsResolvePartialUpdate: build.mutation<
        AssignmentsDriverCallRequestsResolvePartialUpdateApiResponse,
        AssignmentsDriverCallRequestsResolvePartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/driver-call-requests/${queryArg.driverCallRequestId}/resolve/`,
          method: 'PATCH',
          body: queryArg.patchedDriverCallRequest,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['assignments'],
      }),
      assignmentsEventsList: build.query<
        AssignmentsEventsListApiResponse,
        AssignmentsEventsListApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/events/`,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['assignments'],
      }),
      assignmentsEventsCreate: build.mutation<
        AssignmentsEventsCreateApiResponse,
        AssignmentsEventsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/events/`,
          method: 'POST',
          body: queryArg.assignmentEvent,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
        }),
        invalidatesTags: ['assignments'],
      }),
      assignmentsTransferCreate: build.mutation<
        AssignmentsTransferCreateApiResponse,
        AssignmentsTransferCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/transfer/`,
          method: 'POST',
          body: queryArg.assignmentTransfer,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['assignments'],
      }),
      assignmentsTripsList: build.query<
        AssignmentsTripsListApiResponse,
        AssignmentsTripsListApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/trips/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['assignments'],
      }),
      assignmentsTripsActiveList: build.query<
        AssignmentsTripsActiveListApiResponse,
        AssignmentsTripsActiveListApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/${queryArg.id}/trips/active/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['assignments'],
      }),
      assignmentsAssignedMembershipsPartialUpdate: build.mutation<
        AssignmentsAssignedMembershipsPartialUpdateApiResponse,
        AssignmentsAssignedMembershipsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/assigned-memberships/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedAssignedMembership,
        }),
        invalidatesTags: ['assignments'],
      }),
      assignmentsBreaksEventsList: build.query<
        AssignmentsBreaksEventsListApiResponse,
        AssignmentsBreaksEventsListApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/breaks/${queryArg.id}/events/`,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['assignments'],
      }),
      assignmentsBreaksEventsCreate: build.mutation<
        AssignmentsBreaksEventsCreateApiResponse,
        AssignmentsBreaksEventsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/breaks/${queryArg.id}/events/`,
          method: 'POST',
          body: queryArg.assignmentBreakEvent,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
        }),
        invalidatesTags: ['assignments'],
      }),
      assignmentsBulkDeletePartialUpdate: build.mutation<
        AssignmentsBulkDeletePartialUpdateApiResponse,
        AssignmentsBulkDeletePartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/bulk-delete/`,
          method: 'PATCH',
          body: queryArg.patchedBulkAssignmentDelete,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['assignments'],
      }),
      assignmentsBulkDefaultVehicleDriverList: build.query<
        AssignmentsBulkDefaultVehicleDriverListApiResponse,
        AssignmentsBulkDefaultVehicleDriverListApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/bulk/default/vehicle/${queryArg.vehicleId}/driver/${queryArg.driverId}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            attendant_ids: queryArg.attendantIds,
            page: queryArg.page,
            page_size: queryArg.pageSize,
          },
        }),
        providesTags: ['assignments'],
      }),
      assignmentsDriverRetrieve: build.query<
        AssignmentsDriverRetrieveApiResponse,
        AssignmentsDriverRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/driver/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['assignments'],
      }),
      assignmentsExportRetrieve: build.query<
        AssignmentsExportRetrieveApiResponse,
        AssignmentsExportRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/export/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            contains_timestamp: queryArg.containsTimestamp,
            drivers: queryArg.drivers,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            unassigned: queryArg.unassigned,
            vehicles: queryArg.vehicles,
          },
        }),
        providesTags: ['assignments'],
      }),
      assignmentsLocationsList: build.query<
        AssignmentsLocationsListApiResponse,
        AssignmentsLocationsListApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/locations/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            include_completed: queryArg.includeCompleted,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            search: queryArg.search,
          },
        }),
        providesTags: ['assignments'],
      }),
      assignmentsMemberListList: build.query<
        AssignmentsMemberListListApiResponse,
        AssignmentsMemberListListApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/member/list/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            include_completed: queryArg.includeCompleted,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
          },
        }),
        providesTags: ['assignments'],
      }),
      assignmentsTimeRangeCreate: build.mutation<
        AssignmentsTimeRangeCreateApiResponse,
        AssignmentsTimeRangeCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/assignments/time-range/`,
          method: 'POST',
          body: queryArg.assignmentTimeRangeBulkCreate,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['assignments'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as bambiApi };
export type AssignmentsListApiResponse =
  /** status 200  */ PaginatedAssignmentListRead;
export type AssignmentsListApiArg = {
  'Organization-ID'?: string;
  /** Find assignments that contain this specific timestamp within their time range (inclusive of both start and end). When provided, this filter takes precedence and ignores other filter parameters. */
  containsTimestamp?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** Find assignments that have the specific drivers assigned. */
  drivers?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** End of the time range to filter assignments. Used with range_start to find assignments that overlap with the specified time range. */
  rangeEnd?: string;
  /** Start of the time range to filter assignments. Used with range_end to find assignments that overlap with the specified time range. */
  rangeStart?: string;
  /** A search term. */
  search?: string;
  /** Filter for assignments without overlapping trips. When true, returns assignments that contain the time range but have no trips scheduled during that time. */
  unassigned?: boolean;
  /** Find assignments that have the specific vehicles assigned. */
  vehicles?: string;
};
export type AssignmentsCreateApiResponse =
  /** status 201  */ AssignmentBulkCreateRead;
export type AssignmentsCreateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  assignmentBulkCreate: AssignmentBulkCreate;
};
export type AssignmentsRetrieveApiResponse = /** status 200  */ AssignmentRead;
export type AssignmentsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this assignment. */
  id: string;
};
export type AssignmentsPartialUpdateApiResponse =
  /** status 200  */ AssignmentRead;
export type AssignmentsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this assignment. */
  id: string;
  patchedAssignment: PatchedAssignment;
};
export type AssignmentsDestroyApiResponse =
  /** status 204 No response body */ void;
export type AssignmentsDestroyApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this assignment. */
  id: string;
};
export type AssignmentsBreaksListApiResponse =
  /** status 200  */ PaginatedAssignmentBreakListRead;
export type AssignmentsBreaksListApiArg = {
  'Organization-ID'?: string;
  id: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type AssignmentsBreaksCreateApiResponse =
  /** status 201  */ AssignmentBreakRead;
export type AssignmentsBreaksCreateApiArg = {
  'Organization-ID'?: string;
  id: string;
  assignmentBreak: AssignmentBreak;
};
export type AssignmentsBreaksRetrieveApiResponse =
  /** status 200  */ AssignmentBreakRead;
export type AssignmentsBreaksRetrieveApiArg = {
  'Organization-ID'?: string;
  breakId: string;
  id: string;
};
export type AssignmentsBreaksPartialUpdateApiResponse =
  /** status 200  */ AssignmentBreakRead;
export type AssignmentsBreaksPartialUpdateApiArg = {
  'Organization-ID'?: string;
  breakId: string;
  id: string;
  patchedAssignmentBreak: PatchedAssignmentBreak;
};
export type AssignmentsBreaksDestroyApiResponse =
  /** status 204 No response body */ void;
export type AssignmentsBreaksDestroyApiArg = {
  'Organization-ID'?: string;
  breakId: string;
  id: string;
};
export type AssignmentsBreaksActiveListApiResponse =
  /** status 200  */ PaginatedAssignmentBreakListRead;
export type AssignmentsBreaksActiveListApiArg = {
  'Organization-ID'?: string;
  id: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type AssignmentsDriverCallRequestsCreateApiResponse =
  /** status 201  */ DriverCallRequestRead;
export type AssignmentsDriverCallRequestsCreateApiArg = {
  'Organization-ID'?: string;
  id: string;
  driverCallRequest: DriverCallRequest;
};
export type AssignmentsDriverCallRequestsCancelPartialUpdateApiResponse =
  /** status 200  */ DriverCallRequestRead;
export type AssignmentsDriverCallRequestsCancelPartialUpdateApiArg = {
  'Organization-ID'?: string;
  driverCallRequestId: string;
  id: string;
  patchedDriverCallRequest: PatchedDriverCallRequest;
};
export type AssignmentsDriverCallRequestsResolvePartialUpdateApiResponse =
  /** status 200  */ DriverCallRequestRead;
export type AssignmentsDriverCallRequestsResolvePartialUpdateApiArg = {
  'Organization-ID'?: string;
  driverCallRequestId: string;
  id: string;
  patchedDriverCallRequest: PatchedDriverCallRequest;
};
export type AssignmentsEventsListApiResponse =
  /** status 200  */ PaginatedAssignmentEventListRead;
export type AssignmentsEventsListApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  id: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type AssignmentsEventsCreateApiResponse =
  /** status 201  */ AssignmentEventRead;
export type AssignmentsEventsCreateApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  id: string;
  assignmentEvent: AssignmentEvent;
};
export type AssignmentsTransferCreateApiResponse =
  /** status 201  */ AssignmentRead;
export type AssignmentsTransferCreateApiArg = {
  'Organization-ID'?: string;
  id: string;
  assignmentTransfer: AssignmentTransferWrite;
};
export type AssignmentsTripsListApiResponse =
  /** status 200  */ PaginatedAssignmentTripListRead;
export type AssignmentsTripsListApiArg = {
  'Organization-ID'?: string;
  id: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type AssignmentsTripsActiveListApiResponse =
  /** status 200  */ PaginatedAssignmentTripListRead;
export type AssignmentsTripsActiveListApiArg = {
  'Organization-ID'?: string;
  id: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type AssignmentsAssignedMembershipsPartialUpdateApiResponse =
  /** status 200  */ AssignedMembershipRead;
export type AssignmentsAssignedMembershipsPartialUpdateApiArg = {
  id: string;
  patchedAssignedMembership: PatchedAssignedMembership;
};
export type AssignmentsBreaksEventsListApiResponse =
  /** status 200  */ PaginatedAssignmentBreakEventListRead;
export type AssignmentsBreaksEventsListApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  id: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type AssignmentsBreaksEventsCreateApiResponse =
  /** status 201  */ AssignmentBreakEventRead;
export type AssignmentsBreaksEventsCreateApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  id: string;
  assignmentBreakEvent: AssignmentBreakEvent;
};
export type AssignmentsBulkDeletePartialUpdateApiResponse =
  /** status 200  */ BulkAssignmentDelete;
export type AssignmentsBulkDeletePartialUpdateApiArg = {
  'Organization-ID'?: string;
  patchedBulkAssignmentDelete: PatchedBulkAssignmentDelete;
};
export type AssignmentsBulkDefaultVehicleDriverListApiResponse =
  /** status 200  */ PaginatedBulkAssignmentDefaultListRead;
export type AssignmentsBulkDefaultVehicleDriverListApiArg = {
  'Organization-ID'?: string;
  attendantIds?: string;
  driverId: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  vehicleId: string;
};
export type AssignmentsDriverRetrieveApiResponse =
  /** status 200  */ AssignmentRead;
export type AssignmentsDriverRetrieveApiArg = {
  'Organization-ID'?: string;
};
export type AssignmentsExportRetrieveApiResponse = /** status 200  */ Blob;
export type AssignmentsExportRetrieveApiArg = {
  'Organization-ID'?: string;
  /** Find assignments that contain this specific timestamp within their time range (inclusive of both start and end). When provided, this filter takes precedence and ignores other filter parameters. */
  containsTimestamp?: string;
  /** Find assignments that have the specific drivers assigned. */
  drivers?: string;
  /** End of the time range to filter assignments. Used with range_start to find assignments that overlap with the specified time range. */
  rangeEnd?: string;
  /** Start of the time range to filter assignments. Used with range_end to find assignments that overlap with the specified time range. */
  rangeStart?: string;
  /** Filter for assignments without overlapping trips. When true, returns assignments that contain the time range but have no trips scheduled during that time. */
  unassigned?: boolean;
  /** Find assignments that have the specific vehicles assigned. */
  vehicles?: string;
};
export type AssignmentsLocationsListApiResponse =
  /** status 200  */ PaginatedAssignmentLocationListRead;
export type AssignmentsLocationsListApiArg = {
  'Organization-ID'?: string;
  includeCompleted?: boolean;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  rangeEnd?: string;
  rangeStart?: string;
  /** A search term. */
  search?: string;
};
export type AssignmentsMemberListListApiResponse =
  /** status 200  */ PaginatedAssignmentListRead;
export type AssignmentsMemberListListApiArg = {
  'Organization-ID'?: string;
  includeCompleted?: boolean;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  rangeEnd?: string;
  rangeStart?: string;
};
export type AssignmentsTimeRangeCreateApiResponse =
  /** status 201  */ AssignmentTimeRangeBulkCreateRead;
export type AssignmentsTimeRangeCreateApiArg = {
  'Organization-ID'?: string;
  assignmentTimeRangeBulkCreate: AssignmentTimeRangeBulkCreateWrite;
};
export type AssignedVehicle = {
  vehicle: string;
};
export type VehicleCategoryEnum = 'wheelchair' | 'stretcher' | 'ambulatory';
export type AssignedVehicleStorageLocation = {
  latitude: number;
  longitude: number;
};
export type AssignedVehicleStorageLocationRead = {
  /** numerical portion of address, ex. 5C */
  address_number: string;
  /** ISO 3166 3-digit country/region code, ex. CAN */
  country: string;
  /** The full address or geolocation label */
  label: string;
  /** local area, ex. Toronto */
  municipality: string;
  /** community/district, ex. downtown */
  neighborhood: string;
  /** letters/numbers in country-specific format */
  postal_code: string;
  region: string;
  sub_region: string;
  street: string;
  unit_number: string;
  /** ex., apartment */
  unit_type: string;
  latitude: number;
  longitude: number;
};
export type AssignedVehicleRead = {
  vehicle: string;
  nickname: string;
  category: VehicleCategoryEnum;
  color: string;
  make: string;
  model: string;
  year: number;
  license_plate: string;
  storage_location: AssignedVehicleStorageLocationRead;
};
export type AssignedDriver = {
  driver?: string | null;
};
export type AssignedDriverRead = {
  id: string;
  membership: string;
  first_name: string;
  last_name: string;
  driver?: string | null;
  /** The time when this team member clocked in for their crew assignment */
  clocked_in_at: string | null;
  /** The time when this team member clocked out for their crew assignment */
  clocked_out_at: string | null;
  /** Returns whether the driver is currently clocked in, based on
    the assignment status.
    
    NOTE: This uses the status (which relies on the values of
    clocked_in_at and clocked_out_at), and not the AssignmentEvent
    records, to be consistent with the DispatchAssignmentSerializer. */
  is_currently_clocked_in: boolean;
  deleted_at: string | null;
  driver_deleted_at: string | null;
  membership_deleted_at: string | null;
};
export type AssignedAttendant = {
  attendant?: string | null;
};
export type AssignedAttendantRead = {
  id: string;
  membership: string;
  first_name: string;
  last_name: string;
  attendant?: string | null;
};
export type Assignment = {
  start: string;
  end: string;
  vehicle: AssignedVehicle;
  driver: AssignedDriver;
  attendants: AssignedAttendant[];
};
export type DriverCallRequest = {
  /** Comment from driver on reason for the call */
  comment?: string;
};
export type DriverCallRequestRead = {
  id: string;
  assignment: string;
  created_at: string;
  /** Membership of driver that created the call request */
  created_by: string;
  /** Membership of non-associate that resolved the call request */
  resolved_by: string | null;
  canceled_at: string | null;
  resolved_at: string | null;
  /** Comment from driver on reason for the call */
  comment?: string;
};
export type AssignmentVehicleInspection = {};
export type AssignmentVehicleInspectionRead = {
  id: string;
};
export type AssignmentBreak = {
  id?: string;
  start: string;
  end: string;
  break_notes?: string;
};
export type AssignmentBreakStatusEnum = 'complete' | 'in progress' | 'upcoming';
export type AssignmentBreakRead = {
  id?: string;
  start: string;
  end: string;
  assignment_id: string;
  break_notes?: string;
  status: AssignmentBreakStatusEnum;
  started_at: string | null;
  ended_at: string | null;
};
export type AssignmentRead = {
  id: string;
  start: string;
  end: string;
  vehicle: AssignedVehicleRead;
  driver: AssignedDriverRead;
  driver_call_requests: DriverCallRequestRead[];
  attendants: AssignedAttendantRead[];
  /** Uses an annotated value if it exists; otherwise, counts the trips. */
  trip_count: number;
  /** will_call_count is only used by the mobile application; at some point
    we might want to break up the serializers a bit more for clarity,
    or move this to a GET will_call_count.
    
    to avoid expensive n+1 queries, especially when they're not needed,
    this sets the value to None/null when the annotation is not present. */
  will_call_count: number | null;
  vehicle_inspections: AssignmentVehicleInspectionRead[];
  breaks: AssignmentBreakRead[];
};
export type PaginatedAssignmentList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Assignment[];
};
export type PaginatedAssignmentListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AssignmentRead[];
};
export type ValidationErrorEnum = 'validation_error';
export type AssignmentsListRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'invalid';
  detail: string;
};
export type AssignmentsListRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'invalid';
  detail: string;
};
export type AssignmentsListContainsTimestampErrorComponent = {
  attr: 'contains_timestamp';
  code: 'invalid';
  detail: string;
};
export type AssignmentsListVehiclesErrorComponent = {
  attr: 'vehicles';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type AssignmentsListDriversErrorComponent = {
  attr: 'drivers';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type AssignmentsListError =
  | ({
      attr: 'range_start';
    } & AssignmentsListRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & AssignmentsListRangeEndErrorComponent)
  | ({
      attr: 'contains_timestamp';
    } & AssignmentsListContainsTimestampErrorComponent)
  | ({
      attr: 'vehicles';
    } & AssignmentsListVehiclesErrorComponent)
  | ({
      attr: 'drivers';
    } & AssignmentsListDriversErrorComponent);
export type AssignmentsListValidationError = {
  type: ValidationErrorEnum;
  errors: AssignmentsListError[];
};
export type ClientErrorEnum = 'client_error';
export type ParseErrorCodeEnum = 'parse_error';
export type ParseError = {
  code: ParseErrorCodeEnum;
  detail: string;
  attr: string | null;
};
export type ParseErrorResponse = {
  type: ClientErrorEnum;
  errors: ParseError[];
};
export type AssignmentsListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AssignmentsListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type ErrorCode403Enum = 'permission_denied';
export type Error403 = {
  code: ErrorCode403Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse403 = {
  type: ClientErrorEnum;
  errors: Error403[];
};
export type ErrorCode404Enum = 'not_found';
export type Error404 = {
  code: ErrorCode404Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse404 = {
  type: ClientErrorEnum;
  errors: Error404[];
};
export type AssignmentBulkCreate = {
  assignments: Assignment[];
};
export type AssignmentBulkCreateRead = {
  assignments: AssignmentRead[];
};
export type AssignmentsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};
export type AssignmentsCreateAssignmentsNonFieldErrorsErrorComponent = {
  attr: 'assignments.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type AssignmentsCreateAssignmentsIndexNonFieldErrorsErrorComponent = {
  attr: 'assignments.INDEX.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type AssignmentsCreateAssignmentsIndexStartErrorComponent = {
  attr: 'assignments.INDEX.start';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type AssignmentsCreateAssignmentsIndexEndErrorComponent = {
  attr: 'assignments.INDEX.end';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type AssignmentsCreateAssignmentsIndexVehicleNonFieldErrorsErrorComponent =
  {
    attr: 'assignments.INDEX.vehicle.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type AssignmentsCreateAssignmentsIndexVehicleVehicleErrorComponent = {
  attr: 'assignments.INDEX.vehicle.vehicle';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type AssignmentsCreateAssignmentsIndexDriverNonFieldErrorsErrorComponent =
  {
    attr: 'assignments.INDEX.driver.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type AssignmentsCreateAssignmentsIndexDriverDriverErrorComponent = {
  attr: 'assignments.INDEX.driver.driver';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type AssignmentsCreateAssignmentsIndexAttendantsNonFieldErrorsErrorComponent =
  {
    attr: 'assignments.INDEX.attendants.non_field_errors';
    code: 'not_a_list' | 'null' | 'required';
    detail: string;
  };
export type AssignmentsCreateAssignmentsIndexAttendantsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'assignments.INDEX.attendants.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type AssignmentsCreateAssignmentsIndexAttendantsIndexAttendantErrorComponent =
  {
    attr: 'assignments.INDEX.attendants.INDEX.attendant';
    code: 'does_not_exist' | 'incorrect_type';
    detail: string;
  };
export type AssignmentsCreateError =
  | ({
      attr: 'non_field_errors';
    } & AssignmentsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'assignments.non_field_errors';
    } & AssignmentsCreateAssignmentsNonFieldErrorsErrorComponent)
  | ({
      attr: 'assignments.INDEX.non_field_errors';
    } & AssignmentsCreateAssignmentsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'assignments.INDEX.start';
    } & AssignmentsCreateAssignmentsIndexStartErrorComponent)
  | ({
      attr: 'assignments.INDEX.end';
    } & AssignmentsCreateAssignmentsIndexEndErrorComponent)
  | ({
      attr: 'assignments.INDEX.vehicle.non_field_errors';
    } & AssignmentsCreateAssignmentsIndexVehicleNonFieldErrorsErrorComponent)
  | ({
      attr: 'assignments.INDEX.vehicle.vehicle';
    } & AssignmentsCreateAssignmentsIndexVehicleVehicleErrorComponent)
  | ({
      attr: 'assignments.INDEX.driver.non_field_errors';
    } & AssignmentsCreateAssignmentsIndexDriverNonFieldErrorsErrorComponent)
  | ({
      attr: 'assignments.INDEX.driver.driver';
    } & AssignmentsCreateAssignmentsIndexDriverDriverErrorComponent)
  | ({
      attr: 'assignments.INDEX.attendants.non_field_errors';
    } & AssignmentsCreateAssignmentsIndexAttendantsNonFieldErrorsErrorComponent)
  | ({
      attr: 'assignments.INDEX.attendants.INDEX.non_field_errors';
    } & AssignmentsCreateAssignmentsIndexAttendantsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'assignments.INDEX.attendants.INDEX.attendant';
    } & AssignmentsCreateAssignmentsIndexAttendantsIndexAttendantErrorComponent);
export type AssignmentsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: AssignmentsCreateError[];
};
export type AssignmentsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AssignmentsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type AssignmentsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type AssignmentsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};
export type AssignmentsPartialUpdateStartErrorComponent = {
  attr: 'start';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type AssignmentsPartialUpdateEndErrorComponent = {
  attr: 'end';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type AssignmentsPartialUpdateVehicleNonFieldErrorsErrorComponent = {
  attr: 'vehicle.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type AssignmentsPartialUpdateVehicleVehicleErrorComponent = {
  attr: 'vehicle.vehicle';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type AssignmentsPartialUpdateDriverNonFieldErrorsErrorComponent = {
  attr: 'driver.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type AssignmentsPartialUpdateDriverDriverErrorComponent = {
  attr: 'driver.driver';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type AssignmentsPartialUpdateAttendantsNonFieldErrorsErrorComponent = {
  attr: 'attendants.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type AssignmentsPartialUpdateAttendantsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'attendants.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type AssignmentsPartialUpdateAttendantsIndexAttendantErrorComponent = {
  attr: 'attendants.INDEX.attendant';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type AssignmentsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & AssignmentsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'start';
    } & AssignmentsPartialUpdateStartErrorComponent)
  | ({
      attr: 'end';
    } & AssignmentsPartialUpdateEndErrorComponent)
  | ({
      attr: 'vehicle.non_field_errors';
    } & AssignmentsPartialUpdateVehicleNonFieldErrorsErrorComponent)
  | ({
      attr: 'vehicle.vehicle';
    } & AssignmentsPartialUpdateVehicleVehicleErrorComponent)
  | ({
      attr: 'driver.non_field_errors';
    } & AssignmentsPartialUpdateDriverNonFieldErrorsErrorComponent)
  | ({
      attr: 'driver.driver';
    } & AssignmentsPartialUpdateDriverDriverErrorComponent)
  | ({
      attr: 'attendants.non_field_errors';
    } & AssignmentsPartialUpdateAttendantsNonFieldErrorsErrorComponent)
  | ({
      attr: 'attendants.INDEX.non_field_errors';
    } & AssignmentsPartialUpdateAttendantsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'attendants.INDEX.attendant';
    } & AssignmentsPartialUpdateAttendantsIndexAttendantErrorComponent);
export type AssignmentsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: AssignmentsPartialUpdateError[];
};
export type AssignmentsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AssignmentsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedAssignment = {
  start?: string;
  end?: string;
  vehicle?: AssignedVehicle;
  driver?: AssignedDriver;
  attendants?: AssignedAttendant[];
};
export type PatchedAssignmentRead = {
  id?: string;
  start?: string;
  end?: string;
  vehicle?: AssignedVehicleRead;
  driver?: AssignedDriverRead;
  driver_call_requests?: DriverCallRequestRead[];
  attendants?: AssignedAttendantRead[];
  /** Uses an annotated value if it exists; otherwise, counts the trips. */
  trip_count?: number;
  /** will_call_count is only used by the mobile application; at some point
    we might want to break up the serializers a bit more for clarity,
    or move this to a GET will_call_count.
    
    to avoid expensive n+1 queries, especially when they're not needed,
    this sets the value to None/null when the annotation is not present. */
  will_call_count?: number | null;
  vehicle_inspections?: AssignmentVehicleInspectionRead[];
  breaks?: AssignmentBreakRead[];
};
export type AssignmentsDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PaginatedAssignmentBreakList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AssignmentBreak[];
};
export type PaginatedAssignmentBreakListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AssignmentBreakRead[];
};
export type AssignmentsBreaksListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type AssignmentsBreaksCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};
export type AssignmentsBreaksCreateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null' | 'unique';
  detail: string;
};
export type AssignmentsBreaksCreateStartErrorComponent = {
  attr: 'start';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type AssignmentsBreaksCreateEndErrorComponent = {
  attr: 'end';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type AssignmentsBreaksCreateBreakNotesErrorComponent = {
  attr: 'break_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type AssignmentsBreaksCreateError =
  | ({
      attr: 'non_field_errors';
    } & AssignmentsBreaksCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & AssignmentsBreaksCreateIdErrorComponent)
  | ({
      attr: 'start';
    } & AssignmentsBreaksCreateStartErrorComponent)
  | ({
      attr: 'end';
    } & AssignmentsBreaksCreateEndErrorComponent)
  | ({
      attr: 'break_notes';
    } & AssignmentsBreaksCreateBreakNotesErrorComponent);
export type AssignmentsBreaksCreateValidationError = {
  type: ValidationErrorEnum;
  errors: AssignmentsBreaksCreateError[];
};
export type AssignmentsBreaksCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AssignmentsBreaksCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type AssignmentsBreaksRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type AssignmentsBreaksPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};
export type AssignmentsBreaksPartialUpdateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null' | 'unique';
  detail: string;
};
export type AssignmentsBreaksPartialUpdateStartErrorComponent = {
  attr: 'start';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type AssignmentsBreaksPartialUpdateEndErrorComponent = {
  attr: 'end';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type AssignmentsBreaksPartialUpdateBreakNotesErrorComponent = {
  attr: 'break_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type AssignmentsBreaksPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & AssignmentsBreaksPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & AssignmentsBreaksPartialUpdateIdErrorComponent)
  | ({
      attr: 'start';
    } & AssignmentsBreaksPartialUpdateStartErrorComponent)
  | ({
      attr: 'end';
    } & AssignmentsBreaksPartialUpdateEndErrorComponent)
  | ({
      attr: 'break_notes';
    } & AssignmentsBreaksPartialUpdateBreakNotesErrorComponent);
export type AssignmentsBreaksPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: AssignmentsBreaksPartialUpdateError[];
};
export type AssignmentsBreaksPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AssignmentsBreaksPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedAssignmentBreak = {
  id?: string;
  start?: string;
  end?: string;
  break_notes?: string;
};
export type PatchedAssignmentBreakRead = {
  id?: string;
  start?: string;
  end?: string;
  assignment_id?: string;
  break_notes?: string;
  status?: AssignmentBreakStatusEnum;
  started_at?: string | null;
  ended_at?: string | null;
};
export type AssignmentsBreaksDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type AssignmentsBreaksActiveListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type AssignmentsDriverCallRequestsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};
export type AssignmentsDriverCallRequestsCreateCommentErrorComponent = {
  attr: 'comment';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type AssignmentsDriverCallRequestsCreateError =
  | ({
      attr: 'non_field_errors';
    } & AssignmentsDriverCallRequestsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'comment';
    } & AssignmentsDriverCallRequestsCreateCommentErrorComponent);
export type AssignmentsDriverCallRequestsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: AssignmentsDriverCallRequestsCreateError[];
};
export type AssignmentsDriverCallRequestsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AssignmentsDriverCallRequestsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type AssignmentsDriverCallRequestsCancelPartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type AssignmentsDriverCallRequestsCancelPartialUpdateCommentErrorComponent =
  {
    attr: 'comment';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type AssignmentsDriverCallRequestsCancelPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & AssignmentsDriverCallRequestsCancelPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'comment';
    } & AssignmentsDriverCallRequestsCancelPartialUpdateCommentErrorComponent);
export type AssignmentsDriverCallRequestsCancelPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: AssignmentsDriverCallRequestsCancelPartialUpdateError[];
};
export type AssignmentsDriverCallRequestsCancelPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AssignmentsDriverCallRequestsCancelPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedDriverCallRequest = {
  /** Comment from driver on reason for the call */
  comment?: string;
};
export type PatchedDriverCallRequestRead = {
  id?: string;
  assignment?: string;
  created_at?: string;
  /** Membership of driver that created the call request */
  created_by?: string;
  /** Membership of non-associate that resolved the call request */
  resolved_by?: string | null;
  canceled_at?: string | null;
  resolved_at?: string | null;
  /** Comment from driver on reason for the call */
  comment?: string;
};
export type AssignmentsDriverCallRequestsResolvePartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type AssignmentsDriverCallRequestsResolvePartialUpdateCommentErrorComponent =
  {
    attr: 'comment';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type AssignmentsDriverCallRequestsResolvePartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & AssignmentsDriverCallRequestsResolvePartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'comment';
    } & AssignmentsDriverCallRequestsResolvePartialUpdateCommentErrorComponent);
export type AssignmentsDriverCallRequestsResolvePartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: AssignmentsDriverCallRequestsResolvePartialUpdateError[];
};
export type AssignmentsDriverCallRequestsResolvePartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AssignmentsDriverCallRequestsResolvePartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type AssignmentEventEventTypeEnum =
  | 'assignment_event_start'
  | 'assignment_event_end';
export type AssignmentEvent = {
  event_type: AssignmentEventEventTypeEnum;
};
export type AssignmentEventRead = {
  id: string;
  assignment: string;
  created_at: string;
  event_type: AssignmentEventEventTypeEnum;
  membership: string;
  device_requested_at: string | null;
  longitude: number;
  latitude: number;
  location_queried_at: string | null;
  odometer: number | null;
};
export type PaginatedAssignmentEventList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AssignmentEvent[];
};
export type PaginatedAssignmentEventListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AssignmentEventRead[];
};
export type AssignmentsEventsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type AssignmentsEventsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};
export type AssignmentsEventsCreateEventTypeErrorComponent = {
  attr: 'event_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type AssignmentsEventsCreateError =
  | ({
      attr: 'non_field_errors';
    } & AssignmentsEventsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'event_type';
    } & AssignmentsEventsCreateEventTypeErrorComponent);
export type AssignmentsEventsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: AssignmentsEventsCreateError[];
};
export type AssignmentsEventsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AssignmentsEventsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type AssignmentsTransferCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};
export type AssignmentsTransferCreateVehicleNonFieldErrorsErrorComponent = {
  attr: 'vehicle.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type AssignmentsTransferCreateVehicleVehicleErrorComponent = {
  attr: 'vehicle.vehicle';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type AssignmentsTransferCreateDriverNonFieldErrorsErrorComponent = {
  attr: 'driver.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type AssignmentsTransferCreateDriverDriverErrorComponent = {
  attr: 'driver.driver';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type AssignmentsTransferCreateAttendantsNonFieldErrorsErrorComponent = {
  attr: 'attendants.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type AssignmentsTransferCreateAttendantsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'attendants.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type AssignmentsTransferCreateAttendantsIndexAttendantErrorComponent = {
  attr: 'attendants.INDEX.attendant';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type AssignmentsTransferCreateSplitDatetimeErrorComponent = {
  attr: 'split_datetime';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type AssignmentsTransferCreateError =
  | ({
      attr: 'non_field_errors';
    } & AssignmentsTransferCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'vehicle.non_field_errors';
    } & AssignmentsTransferCreateVehicleNonFieldErrorsErrorComponent)
  | ({
      attr: 'vehicle.vehicle';
    } & AssignmentsTransferCreateVehicleVehicleErrorComponent)
  | ({
      attr: 'driver.non_field_errors';
    } & AssignmentsTransferCreateDriverNonFieldErrorsErrorComponent)
  | ({
      attr: 'driver.driver';
    } & AssignmentsTransferCreateDriverDriverErrorComponent)
  | ({
      attr: 'attendants.non_field_errors';
    } & AssignmentsTransferCreateAttendantsNonFieldErrorsErrorComponent)
  | ({
      attr: 'attendants.INDEX.non_field_errors';
    } & AssignmentsTransferCreateAttendantsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'attendants.INDEX.attendant';
    } & AssignmentsTransferCreateAttendantsIndexAttendantErrorComponent)
  | ({
      attr: 'split_datetime';
    } & AssignmentsTransferCreateSplitDatetimeErrorComponent);
export type AssignmentsTransferCreateValidationError = {
  type: ValidationErrorEnum;
  errors: AssignmentsTransferCreateError[];
};
export type AssignmentsTransferCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AssignmentsTransferCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type AssignmentTransfer = {};
export type AssignmentTransferRead = {};
export type AssignmentTransferWrite = {
  vehicle: AssignedVehicle;
  driver: AssignedDriver;
  attendants: AssignedAttendant[];
  split_datetime: string;
};
export type OverrideStatusEnum =
  | 'requested'
  | 'pending'
  | 'assigned'
  | 'en route'
  | 'at pickup'
  | 'transporting'
  | 'at dropoff'
  | 'completed'
  | 'canceled'
  | 'rejected';
export type SpaceTypeEnum =
  | 'wheelchair'
  | 'wheelchair xl'
  | 'broda chair'
  | 'geri chair'
  | 'stretcher'
  | 'stretcher xl'
  | 'ambulatory'
  | 'delivery';
export type ServiceTypeEnum =
  | 'curb-to-curb'
  | 'door-to-door'
  | 'door-through-door'
  | 'person-to-person';
export type SeatEquipmentEnum = 'booster-seat' | 'car-seat';
export type BlankEnum = '';
export type AssignmentTrip = {
  id?: string;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id?: string;
  /** Current status of this trip */
  status?: OverrideStatusEnum;
  scheduled_pickup_at: string;
  estimated_dropoff_at: string;
  /** The time of the passenger's appointment */
  appointment_at?: string | null;
  /** The time the trip was canceled */
  canceled_at?: string | null;
  /** Whether the passenger will call when it is time to be picked up */
  is_will_call?: boolean;
  /** Whether the passenger has called in that they are ready to be picked up */
  is_will_call_activated?: boolean;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type: ServiceTypeEnum;
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes entered by the driver */
  driver_entered_notes?: string;
  is_oxygen_required?: boolean;
  num_attendants_needed?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  estimated_distance_miles?: number | null;
};
export type PassengerMinimalReadOnly = {};
export type PronounEnum = 'she' | 'he' | 'they';
export type GenderEnum = 'female' | 'male' | 'other';
export type PassengerMinimalReadOnlyRead = {
  id: string;
  first_name: string;
  last_name: string;
  full_name: string;
  preferred_name: string;
  pronoun: PronounEnum;
  /** Patient gender according to their primary insurance */
  gender: GenderEnum;
  dob: string | null;
  weight: number | null;
  phone_number: string | null;
  /** email address (unique in organization) */
  email: string | null;
  notes: string;
};
export type CurrentTaskEnum = 'pickup' | 'dropoff';
export type PurposeEnum = 'pickup' | 'dropoff';
export type StairEquipmentEnum = 'ramp' | 'stair-chair';
export type AssignmentTripLocationDetail = {
  id?: string;
  /** Purpose of this location, pickup, dropoff, etc. */
  purpose: PurposeEnum;
  /** The number of stairs at this location */
  num_stairs?: number;
  /** Stair equipment required for this location */
  stair_equipment?: StairEquipmentEnum | BlankEnum;
  /** Name of contact for this location, if not passenger */
  contact_name?: string;
  /** Phone number of contact for this location, if not passenger */
  contact_phone_number?: string | null;
  /** Notes visible to the driver for this location */
  driver_notes?: string;
};
export type AssignmentTripLocation = {
  /** numerical portion of address, ex. 5C */
  address_number?: string;
  /** ISO 3166 3-digit country/region code, ex. CAN */
  country?: string;
  /** local area, ex. Toronto */
  municipality?: string;
  /** community/district, ex. downtown */
  neighborhood?: string;
  /** letters/numbers in country-specific format */
  postal_code?: string;
  region?: string;
  sub_region?: string;
  street?: string;
  unit_number?: string;
  /** ex., apartment */
  unit_type?: string;
  latitude: number;
  longitude: number;
};
export type AssignmentTripLocationRead = {
  /** numerical portion of address, ex. 5C */
  address_number?: string;
  /** ISO 3166 3-digit country/region code, ex. CAN */
  country?: string;
  /** The full address or geolocation label */
  label: string;
  detail: string;
  /** local area, ex. Toronto */
  municipality?: string;
  /** community/district, ex. downtown */
  neighborhood?: string;
  /** letters/numbers in country-specific format */
  postal_code?: string;
  region?: string;
  sub_region?: string;
  street?: string;
  unit_number?: string;
  /** ex., apartment */
  unit_type?: string;
  latitude: number;
  longitude: number;
  /** Whether or not the location is the result of an AWS geolookup operation. */
  is_geocoded: boolean;
};
export type AssignmentTripLocationDetailRead = {
  id?: string;
  /** Purpose of this location, pickup, dropoff, etc. */
  purpose: PurposeEnum;
  location: AssignmentTripLocationRead;
  /** The number of stairs at this location */
  num_stairs?: number;
  /** Stair equipment required for this location */
  stair_equipment?: StairEquipmentEnum | BlankEnum;
  /** Name of contact for this location, if not passenger */
  contact_name?: string;
  /** Phone number of contact for this location, if not passenger */
  contact_phone_number?: string | null;
  /** Notes visible to the driver for this location */
  driver_notes?: string;
};
export type MissingRequiredSignaturesEnum =
  | 'pickup_passenger'
  | 'dropoff_passenger'
  | 'pickup_driver'
  | 'dropoff_driver';
export type AssignmentTripPayer = {};
export type PayerTypeEnum = 'insurance' | 'broker' | 'private';
export type AssignmentTripPayerSettings = {};
export type AssignmentTripPayerSettingsRead = {
  requires_signature_pickup_passenger: boolean;
  requires_signature_dropoff_passenger: boolean;
  requires_signature_pickup_driver: boolean;
  requires_signature_dropoff_driver: boolean;
  requires_odometer_on_start: boolean;
  requires_odometer_on_pickup: boolean;
  requires_odometer_on_completion: boolean;
};
export type AssignmentTripPayerRead = {
  id: string;
  /** Name the organization uses to refer to this payer across the app */
  display_name: string;
  payer_type: PayerTypeEnum;
  settings: AssignmentTripPayerSettingsRead;
};
export type AssignmentTripTiming = {};
export type AssignmentTripTimingRead = {
  /** Estimated arrival at pickup location per vehicle's last location log */
  estimated_pickup_arrival_time: string | null;
  is_on_time: boolean | null;
  delayed_by_seconds: number | null;
  /** Last time this timing was calculated */
  last_calculated_at: string | null;
  /** Estimated time this trip will be completed per vehicle's last location log */
  estimated_completion_time: string | null;
};
export type AssignmentTripRead = {
  id?: string;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id?: string;
  /** Current status of this trip */
  status?: OverrideStatusEnum;
  passenger: PassengerMinimalReadOnlyRead;
  scheduled_pickup_at: string;
  estimated_dropoff_at: string;
  current_task: CurrentTaskEnum;
  current_task_at: string;
  pickup: AssignmentTripLocationDetailRead;
  dropoff: AssignmentTripLocationDetailRead;
  /** List of required signatures considered missing for trip status. */
  missing_required_signatures: MissingRequiredSignaturesEnum[];
  multiload_id: string | null;
  /** The time of the passenger's appointment */
  appointment_at?: string | null;
  /** The time the trip was canceled */
  canceled_at?: string | null;
  /** Whether the passenger will call when it is time to be picked up */
  is_will_call?: boolean;
  /** Whether the passenger has called in that they are ready to be picked up */
  is_will_call_activated?: boolean;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type: ServiceTypeEnum;
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes entered by the driver */
  driver_entered_notes?: string;
  is_oxygen_required?: boolean;
  oxygen_liters_per_min: number | null;
  num_attendants_needed?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  payer: AssignmentTripPayerRead;
  timing: AssignmentTripTimingRead | null;
  estimated_distance_miles?: number | null;
};
export type PaginatedAssignmentTripList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AssignmentTrip[];
};
export type PaginatedAssignmentTripListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AssignmentTripRead[];
};
export type AssignmentsTripsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type AssignmentsTripsActiveListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type AssignedMembership = {
  start: string;
  end: string;
  /** The time when this team member clocked out for their crew assignment */
  clocked_out_at?: string | null;
};
export type AssignedMembershipRead = {
  id: string;
  assignment: string;
  start: string;
  end: string;
  membership: string;
  driver: string | null;
  attendant: string | null;
  /** The time when this team member clocked in for their crew assignment */
  clocked_in_at: string | null;
  /** The time when this team member clocked out for their crew assignment */
  clocked_out_at?: string | null;
  deleted_at: string | null;
};
export type AssignmentsAssignedMembershipsPartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type AssignmentsAssignedMembershipsPartialUpdateStartErrorComponent = {
  attr: 'start';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type AssignmentsAssignedMembershipsPartialUpdateEndErrorComponent = {
  attr: 'end';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type AssignmentsAssignedMembershipsPartialUpdateClockedOutAtErrorComponent =
  {
    attr: 'clocked_out_at';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type AssignmentsAssignedMembershipsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & AssignmentsAssignedMembershipsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'start';
    } & AssignmentsAssignedMembershipsPartialUpdateStartErrorComponent)
  | ({
      attr: 'end';
    } & AssignmentsAssignedMembershipsPartialUpdateEndErrorComponent)
  | ({
      attr: 'clocked_out_at';
    } & AssignmentsAssignedMembershipsPartialUpdateClockedOutAtErrorComponent);
export type AssignmentsAssignedMembershipsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: AssignmentsAssignedMembershipsPartialUpdateError[];
};
export type AssignmentsAssignedMembershipsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AssignmentsAssignedMembershipsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedAssignedMembership = {
  start?: string;
  end?: string;
  /** The time when this team member clocked out for their crew assignment */
  clocked_out_at?: string | null;
};
export type PatchedAssignedMembershipRead = {
  id?: string;
  assignment?: string;
  start?: string;
  end?: string;
  membership?: string;
  driver?: string | null;
  attendant?: string | null;
  /** The time when this team member clocked in for their crew assignment */
  clocked_in_at?: string | null;
  /** The time when this team member clocked out for their crew assignment */
  clocked_out_at?: string | null;
  deleted_at?: string | null;
};
export type AssignmentBreakEventEventTypeEnum =
  | 'assignment_break_event_start'
  | 'assignment_break_event_end';
export type AssignmentBreakEvent = {
  event_type: AssignmentBreakEventEventTypeEnum;
};
export type AssignmentBreakEventRead = {
  id: string;
  assignment_break: string;
  created_at: string;
  event_type: AssignmentBreakEventEventTypeEnum;
  membership: string;
  device_requested_at: string | null;
  longitude: number;
  latitude: number;
  location_queried_at: string | null;
  odometer: number | null;
};
export type PaginatedAssignmentBreakEventList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AssignmentBreakEvent[];
};
export type PaginatedAssignmentBreakEventListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AssignmentBreakEventRead[];
};
export type AssignmentsBreaksEventsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type AssignmentsBreaksEventsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};
export type AssignmentsBreaksEventsCreateEventTypeErrorComponent = {
  attr: 'event_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type AssignmentsBreaksEventsCreateError =
  | ({
      attr: 'non_field_errors';
    } & AssignmentsBreaksEventsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'event_type';
    } & AssignmentsBreaksEventsCreateEventTypeErrorComponent);
export type AssignmentsBreaksEventsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: AssignmentsBreaksEventsCreateError[];
};
export type AssignmentsBreaksEventsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AssignmentsBreaksEventsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BulkAssignmentDelete = {
  assignment_ids: string[];
};
export type AssignmentsBulkDeletePartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};
export type AssignmentsBulkDeletePartialUpdateAssignmentIdsErrorComponent = {
  attr: 'assignment_ids';
  code: 'min_length' | 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type AssignmentsBulkDeletePartialUpdateAssignmentIdsIndexErrorComponent =
  {
    attr: 'assignment_ids.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type AssignmentsBulkDeletePartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & AssignmentsBulkDeletePartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'assignment_ids';
    } & AssignmentsBulkDeletePartialUpdateAssignmentIdsErrorComponent)
  | ({
      attr: 'assignment_ids.INDEX';
    } & AssignmentsBulkDeletePartialUpdateAssignmentIdsIndexErrorComponent);
export type AssignmentsBulkDeletePartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: AssignmentsBulkDeletePartialUpdateError[];
};
export type AssignmentsBulkDeletePartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AssignmentsBulkDeletePartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedBulkAssignmentDelete = {
  assignment_ids?: string[];
};
export type BulkAssignmentDefault = {
  id?: string;
  /** a (sorted) list of attendant ids */
  attendant_ids?: string[];
  sunday_start?: string | null;
  sunday_duration_minutes?: number | null;
  monday_start?: string | null;
  monday_duration_minutes?: number | null;
  tuesday_start?: string | null;
  tuesday_duration_minutes?: number | null;
  wednesday_start?: string | null;
  wednesday_duration_minutes?: number | null;
  thursday_start?: string | null;
  thursday_duration_minutes?: number | null;
  friday_start?: string | null;
  friday_duration_minutes?: number | null;
  saturday_start?: string | null;
  saturday_duration_minutes?: number | null;
};
export type BulkAssignmentDefaultRead = {
  id?: string;
  vehicle_id: string;
  driver_id: string;
  /** a (sorted) list of attendant ids */
  attendant_ids?: string[];
  sunday_start?: string | null;
  sunday_duration_minutes?: number | null;
  monday_start?: string | null;
  monday_duration_minutes?: number | null;
  tuesday_start?: string | null;
  tuesday_duration_minutes?: number | null;
  wednesday_start?: string | null;
  wednesday_duration_minutes?: number | null;
  thursday_start?: string | null;
  thursday_duration_minutes?: number | null;
  friday_start?: string | null;
  friday_duration_minutes?: number | null;
  saturday_start?: string | null;
  saturday_duration_minutes?: number | null;
};
export type PaginatedBulkAssignmentDefaultList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: BulkAssignmentDefault[];
};
export type PaginatedBulkAssignmentDefaultListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: BulkAssignmentDefaultRead[];
};
export type AssignmentsBulkDefaultVehicleDriverListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type AssignmentsDriverRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type AssignmentLocation = {
  start: string;
  end: string;
  vehicle: AssignedVehicle;
  driver: AssignedDriver;
  attendants: AssignedAttendant[];
};
export type LocationLogEntryRead = {
  uuid?: string;
  location_log_entry: string;
  timestamp: string;
  latitude: number;
  longitude: number;
  odometer: number;
  heading: number;
};
export type AssignmentLocationRead = {
  id: string;
  start: string;
  end: string;
  latest_location: LocationLogEntryRead;
  vehicle: AssignedVehicleRead;
  driver: AssignedDriverRead;
  attendants: AssignedAttendantRead[];
  /** Uses an annotated value if it exists; otherwise, counts the trips. */
  trip_count: number;
};
export type PaginatedAssignmentLocationList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AssignmentLocation[];
};
export type PaginatedAssignmentLocationListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AssignmentLocationRead[];
};
export type AssignmentsLocationsListRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'invalid';
  detail: string;
};
export type AssignmentsLocationsListRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'invalid';
  detail: string;
};
export type AssignmentsLocationsListError =
  | ({
      attr: 'range_start';
    } & AssignmentsLocationsListRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & AssignmentsLocationsListRangeEndErrorComponent);
export type AssignmentsLocationsListValidationError = {
  type: ValidationErrorEnum;
  errors: AssignmentsLocationsListError[];
};
export type AssignmentsLocationsListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AssignmentsLocationsListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type AssignmentsMemberListListRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'invalid';
  detail: string;
};
export type AssignmentsMemberListListRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'invalid';
  detail: string;
};
export type AssignmentsMemberListListError =
  | ({
      attr: 'range_start';
    } & AssignmentsMemberListListRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & AssignmentsMemberListListRangeEndErrorComponent);
export type AssignmentsMemberListListValidationError = {
  type: ValidationErrorEnum;
  errors: AssignmentsMemberListListError[];
};
export type AssignmentsMemberListListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AssignmentsMemberListListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type AssignmentTimeRangeBulkCreate = {};
export type AssignmentTimeRangeBulkCreateRead = {
  assignments: AssignmentRead[];
};
export type AssignedDays = {};
export type DayEnum =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday';
export type AssignedDaysWrite = {
  day: DayEnum;
  start: string;
  duration_minutes: number;
};
export type AssignmentTimeRangeBulkCreateWrite = {
  range_start: string;
  range_end: string;
  vehicle: AssignedVehicle;
  driver: AssignedDriver;
  attendants: AssignedAttendant[];
  save_as_default: boolean;
  assigned_days: AssignedDaysWrite[];
};
export type AssignmentsTimeRangeCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};
export type AssignmentsTimeRangeCreateRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type AssignmentsTimeRangeCreateRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type AssignmentsTimeRangeCreateVehicleNonFieldErrorsErrorComponent = {
  attr: 'vehicle.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type AssignmentsTimeRangeCreateVehicleVehicleErrorComponent = {
  attr: 'vehicle.vehicle';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type AssignmentsTimeRangeCreateDriverNonFieldErrorsErrorComponent = {
  attr: 'driver.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type AssignmentsTimeRangeCreateDriverDriverErrorComponent = {
  attr: 'driver.driver';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type AssignmentsTimeRangeCreateAttendantsNonFieldErrorsErrorComponent = {
  attr: 'attendants.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type AssignmentsTimeRangeCreateAttendantsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'attendants.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type AssignmentsTimeRangeCreateAttendantsIndexAttendantErrorComponent = {
  attr: 'attendants.INDEX.attendant';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type AssignmentsTimeRangeCreateSaveAsDefaultErrorComponent = {
  attr: 'save_as_default';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type AssignmentsTimeRangeCreateAssignedDaysNonFieldErrorsErrorComponent =
  {
    attr: 'assigned_days.non_field_errors';
    code: 'not_a_list' | 'null' | 'required';
    detail: string;
  };
export type AssignmentsTimeRangeCreateAssignedDaysIndexNonFieldErrorsErrorComponent =
  {
    attr: 'assigned_days.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type AssignmentsTimeRangeCreateAssignedDaysIndexDayErrorComponent = {
  attr: 'assigned_days.INDEX.day';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type AssignmentsTimeRangeCreateAssignedDaysIndexStartErrorComponent = {
  attr: 'assigned_days.INDEX.start';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type AssignmentsTimeRangeCreateAssignedDaysIndexDurationMinutesErrorComponent =
  {
    attr: 'assigned_days.INDEX.duration_minutes';
    code: 'invalid' | 'max_string_length' | 'null' | 'required';
    detail: string;
  };
export type AssignmentsTimeRangeCreateError =
  | ({
      attr: 'non_field_errors';
    } & AssignmentsTimeRangeCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'range_start';
    } & AssignmentsTimeRangeCreateRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & AssignmentsTimeRangeCreateRangeEndErrorComponent)
  | ({
      attr: 'vehicle.non_field_errors';
    } & AssignmentsTimeRangeCreateVehicleNonFieldErrorsErrorComponent)
  | ({
      attr: 'vehicle.vehicle';
    } & AssignmentsTimeRangeCreateVehicleVehicleErrorComponent)
  | ({
      attr: 'driver.non_field_errors';
    } & AssignmentsTimeRangeCreateDriverNonFieldErrorsErrorComponent)
  | ({
      attr: 'driver.driver';
    } & AssignmentsTimeRangeCreateDriverDriverErrorComponent)
  | ({
      attr: 'attendants.non_field_errors';
    } & AssignmentsTimeRangeCreateAttendantsNonFieldErrorsErrorComponent)
  | ({
      attr: 'attendants.INDEX.non_field_errors';
    } & AssignmentsTimeRangeCreateAttendantsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'attendants.INDEX.attendant';
    } & AssignmentsTimeRangeCreateAttendantsIndexAttendantErrorComponent)
  | ({
      attr: 'save_as_default';
    } & AssignmentsTimeRangeCreateSaveAsDefaultErrorComponent)
  | ({
      attr: 'assigned_days.non_field_errors';
    } & AssignmentsTimeRangeCreateAssignedDaysNonFieldErrorsErrorComponent)
  | ({
      attr: 'assigned_days.INDEX.non_field_errors';
    } & AssignmentsTimeRangeCreateAssignedDaysIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'assigned_days.INDEX.day';
    } & AssignmentsTimeRangeCreateAssignedDaysIndexDayErrorComponent)
  | ({
      attr: 'assigned_days.INDEX.start';
    } & AssignmentsTimeRangeCreateAssignedDaysIndexStartErrorComponent)
  | ({
      attr: 'assigned_days.INDEX.duration_minutes';
    } & AssignmentsTimeRangeCreateAssignedDaysIndexDurationMinutesErrorComponent);
export type AssignmentsTimeRangeCreateValidationError = {
  type: ValidationErrorEnum;
  errors: AssignmentsTimeRangeCreateError[];
};
export type AssignmentsTimeRangeCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AssignmentsTimeRangeCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export const {
  useAssignmentsListQuery,
  useLazyAssignmentsListQuery,
  useAssignmentsCreateMutation,
  useAssignmentsRetrieveQuery,
  useLazyAssignmentsRetrieveQuery,
  useAssignmentsPartialUpdateMutation,
  useAssignmentsDestroyMutation,
  useAssignmentsBreaksListQuery,
  useLazyAssignmentsBreaksListQuery,
  useAssignmentsBreaksCreateMutation,
  useAssignmentsBreaksRetrieveQuery,
  useLazyAssignmentsBreaksRetrieveQuery,
  useAssignmentsBreaksPartialUpdateMutation,
  useAssignmentsBreaksDestroyMutation,
  useAssignmentsBreaksActiveListQuery,
  useLazyAssignmentsBreaksActiveListQuery,
  useAssignmentsDriverCallRequestsCreateMutation,
  useAssignmentsDriverCallRequestsCancelPartialUpdateMutation,
  useAssignmentsDriverCallRequestsResolvePartialUpdateMutation,
  useAssignmentsEventsListQuery,
  useLazyAssignmentsEventsListQuery,
  useAssignmentsEventsCreateMutation,
  useAssignmentsTransferCreateMutation,
  useAssignmentsTripsListQuery,
  useLazyAssignmentsTripsListQuery,
  useAssignmentsTripsActiveListQuery,
  useLazyAssignmentsTripsActiveListQuery,
  useAssignmentsAssignedMembershipsPartialUpdateMutation,
  useAssignmentsBreaksEventsListQuery,
  useLazyAssignmentsBreaksEventsListQuery,
  useAssignmentsBreaksEventsCreateMutation,
  useAssignmentsBulkDeletePartialUpdateMutation,
  useAssignmentsBulkDefaultVehicleDriverListQuery,
  useLazyAssignmentsBulkDefaultVehicleDriverListQuery,
  useAssignmentsDriverRetrieveQuery,
  useLazyAssignmentsDriverRetrieveQuery,
  useAssignmentsExportRetrieveQuery,
  useLazyAssignmentsExportRetrieveQuery,
  useAssignmentsLocationsListQuery,
  useLazyAssignmentsLocationsListQuery,
  useAssignmentsMemberListListQuery,
  useLazyAssignmentsMemberListListQuery,
  useAssignmentsTimeRangeCreateMutation,
} = injectedRtkApi;
